import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 60px;
  align-items: flex-start;
`;

export const JobInfo = styled.div`
  display: flex;
  flex: 1;

  ${mediaMaxWidth.tablet`
    flex-direction: column;
  `}
`;

export const JobTitle = styled.div`
  display: flex;
  flex: 1;
  font-weight: 700;
  margin-top: 10px;
  max-height: 45px;
  overflow: hidden;

  ${mediaMaxWidth.tablet`
    max-height: unset;
    width: calc(100vw - 95px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  `}
`;

export const JobLocation = styled.div`
  display: flex;
  width: 150px;
  margin-top: 10px;
  max-height: 45px;
  overflow: hidden;

  ${mediaMaxWidth.smallDesktop`
    width: 200px;
  `}

  ${mediaMaxWidth.tablet`
    max-height: unset;
    margin-top: 0;
    width: calc(100vw - 95px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  `}
`;

export const JobActions = styled.div`
  width: 50px;
  height: 60px;

  .button-group {
    z-index: unset;
    top: 0;

    ul {
      min-width: 190px;
      left: -153px;
    }

    li {
      width: 170px;
    }
  }

  ${mediaMaxWidth.tablet`
    .button-group {
      top: 10px;
    }
  `}
`;
